import React, { useMemo } from 'react'

import ListPagination from '~/components/ListPagination'
import Loading from '~/components/Loading'
import LoadingPopUp from '~/components/LoadingPopUp'
import Table from '~/components/Table'
import { useAlert } from '~/hooks/useAlert'
import { useSWRSort } from '~/hooks/useSWRSort'

import { schema } from './schemas'
import { schemaWithMetrics } from './schemas/with-metrics'

const AdsProductsTable = ({ adType = null }: { adType: CampaignAdType }) => {
  const {
    data,
    total,
    page,
    perPage,
    sortDirection,
    sortKey,
    handleSortList,
    loading,
    error,
    isValidating,
    handlePagination,
    handleItemsPerPage
  } = useSWRSort<CampaignProduct[]>()

  const [AlertOnError] = useAlert(error)

  const currentSchema = useMemo(
    () => (adType === 'sponsored_brand' ? schemaWithMetrics() : schema()),
    [adType]
  )

  return (
    <>
      <AlertOnError />

      <Loading status={loading && !data}>Carregando produtos...</Loading>

      <LoadingPopUp
        isActive={isValidating || loading}
        text="Atualizando lista de produtos..."
      />

      {/* Sem moldura própria, diferente da `AdsTable`: esta tabela nunca é usada
          solta — os quatro pontos de uso a embrulham num painel com o título
          "Produtos relacionados". A moldura de dentro virava card dentro de card,
          e é o painel de fora que carrega o título que o desenho pede. */}
      <Table
        schema={currentSchema}
        data={data}
        total={total}
        striped
        sideBorder
        smallerRowPadding
        activeSortDirection={sortDirection}
        activeSortKey={sortKey}
        onSort={handleSortList}
      />

      <footer>
        <ListPagination
          total={total}
          label={total > 1 ? 'produtos' : 'produto'}
          currentPage={page}
          itemsPerPage={perPage}
          menuPlacement="top"
          onClickPagination={handlePagination}
          onItemsPerPageChange={handleItemsPerPage}
        />
      </footer>
    </>
  )
}

export default AdsProductsTable
